import type { SVGProps } from "react";
export function WinampLogoFilled(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m9.68302.666626c.27847 0 .46668.284186.35788.540554l-3.77595 8.90432c-.09461.2231-.31349.3681-.55584.3681h-1.98667c-.27847 0-.46664-.2842-.35792-.54062l3.77599-8.90431c.09461-.223122.31348-.368044.55584-.368044zm2.11518 4.853754c.2784 0 .4666.28419.3579.54056l-3.77602 8.90426c-.09462.2232-.31349.3681-.55585.3681h-1.98666c-.27848 0-.46665-.2842-.35792-.5406l3.77599-8.90427c.09461-.22313.31348-.36805.55584-.36805z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
